'use strict';

import {formatPostalAddress} from '../../../../services/locations/locationAddress/util'


export default function(angularModule) {
  angularModule.controller('ContactEditorCtrl',
    function (campaign, $scope, $state, pageInfo, $stateParams, reviewGenService,
              $log, stringService, updateService, accountsService, locations, locationService,
              $timeout, $uibModalStack, $rootScope, confirmService, $q) {
    var vm = this;
    vm.mode = pageInfo.mode;

    vm.accountConfig = {
      required: true,
      accountId: null,
      disableDropdown: vm.mode == "edit",
      showAccountSelection: false,
      editPage: true
    };

    vm.toNameAddress = function( location){
      let nameAddress=""
      if(location.name){
        nameAddress+=location.name
        if(location.address)
          nameAddress+= " - " + formatPostalAddress(location.address)
      }
      return nameAddress
    }

    setCampaignLocations()

    if (vm.mode == "create") {
      vm.accountConfig.accountId = accountsService.getCurrentAccount();
    }

    vm.defaultContact = function () {
      return {
        name: ''
      }
    };

    vm.pageStrings = stringService.adminStrings(vm.mode);

    vm.findContactType = function (contactType) {
      return _.findWhere(vm.contactTypes, {id: contactType})
    };

    function setCampaignLocations() {
      if (campaign.groupId && !campaign.groupId.startsWith("all-")) {
        locationService.loadLocationGroup(campaign.groupId).then(function (data) {
          vm.locations = _.sortBy(data
            .map(locationService.formatLocation)
            .map(location => {
              location.id = location.locationId.substr(7);
              location.name = location.summary;
              location.nameAddress = vm.toNameAddress(location)
              return location;
            }), 'name');
        });
      }
      else {
        const locationsWithNameAddress = locations.map(x => {x.nameAddress = vm.toNameAddress(x); return x})
        vm.locations = locationsWithNameAddress
      }
    }

    function checkForDuplicates(response) {

      if (response.status == 201) {
        processSuccessfulAddContact(response)
        $rootScope.$broadcast('contactCreated', response.data);
      }
      if (response.status == 202) {
        vm.openConfirmRestartContact();
      }
    }

    vm.openConfirmRestartContact = function () {

      confirmService.confirm(
        'This contact already exists',
        'This contact already exists. Are you sure you want to requeue this contact? Any existing queued events for this contact will still take place.',
        confirmService.QUESTION
      ).then((yesOrNo) => {
        if (yesOrNo) {
          vm.mode = "edit"
          reviewGenService.restartContact(vm.contact).then(processSuccessfulAddContact,handleError);
        }
      });

    };

    function processSuccessfulAddContact(response) {
      vm.newContact = response.data;
      var updateInfo = {
        status: "Active",
        type: "contact",
        title: "Contact",
        destinationRole: "manage",
        notificationType: "detail",
        actions: [{action: vm.mode}],
        entity: vm.newContact,
        id: vm.newContact._id.$oid,
        name: vm.newContact.name,
        accountId: accountsService.getCurrentAccount(),
        searchParam: vm.newContact.name
      };
      updateService.registerSuccessfulUpdate(updateInfo, true);

      $scope.$emit("createEntitySuccess", {data: vm.newContact, type: "contact"});
      $uibModalStack.dismissAll();

      vm.state = 'Success';
    }

    function handleError(response) {
      var errorDetail = 'Please contact support';
      if (response.status == 422) {
        errorDetail = response.data
        vm.errorMsg = 'Error ' + vm.pageStrings.errorAction + ' contact'
      }
      else {
        if (response.data && response.data.error.code) {
          var errorCode = response.data.error.code;

          if (errorCode == 'contacts.edit.contactname.duplicate') {
            errorDetail = 'This contactname already exists. Contactnames must be unique.';
          }
        }
        vm.errorMsg = 'Error ' + vm.pageStrings.errorAction + ' contact!';
      }

      vm.errorDetail = errorDetail;
      vm.state = 'Loaded';
    }

    vm.openResetPasswordModal = function () {
      vm.passwordResetState = "Editing";
      vm.passwordModalCloseText = "Cancel";
      vm.contact.password = '';
      vm.contact.confirmPassword = '';

      $('#resetPasswordModal').modal();
    };


    vm.createEditContact = function (isFormValid) {
      vm.state = 'PendingConfirmation';
      vm.formSubmitted = true;

      if (!isFormValid) {
        $log.info('Missing contact data');
        return;
      }

      // check existing delivery methods
      let warnings = [];
      let deliveryTypes = campaign.deliveryMethods.map(method => method.type)
      if (!vm.contact.email && deliveryTypes.indexOf("email") !== -1) {
        warnings.push("email address")
      }
      if (!vm.contact.phone && deliveryTypes.indexOf("sms") !== -1) {
        warnings.push("phone number")
      }

      let preCheck = null;
      if (warnings.length > 0) {
        preCheck = confirmService.confirm("Missing delivery data", `You are missing some contact information which is needed to gather
          their input for this campaign (${warnings.join(', ')}).  Are you sure you want to proceed?  If so, this contact will not be able
          to receive the relevant communications.`, confirmService.WARNING)
      } else {
        preCheck = $q.when(true)
      }

      preCheck.then((proceed) => {
        if (!proceed) {
          return;
        }
        if (vm.mode == "create") {
          reviewGenService.addContact(vm.contact).then(checkForDuplicates).catch(handleError);
        }
        else {
          let shouldMoveReviewsCheck = null;
          if (vm.contact.locationId != vm.originalContact.locationId) {
            shouldMoveReviewsCheck = reviewGenService.getContactReviewCount(vm.contact._id.$oid).then((counts) => {
              if (counts.reviews != 0) {
                return confirmService.prompt({
                  heading: "Move existing reviews",
                  message: `This contact has submitted ${counts.reviews} review${counts.reviews != 0 ? 's' : ''} across ${counts.locations}
                    locations. Would you like to move these reviews to the new location you selected?`,
                  theme: confirmService.WARNING,
                  actions: [{label: "No, Don't move reviews", resolve: false, btnType: "btn-outline-secondary"}, {label: "Yes, move reviews", resolve: true, btnType: "btn-secondary"}],
                  defaultAction: {resolve: false}
                }).then(success => success.value, rejected => false)
              } else {
                return $q.when(false)
              }
            })
          } else {
            shouldMoveReviewsCheck = $q.when(false)
          }
          shouldMoveReviewsCheck.then(shouldMove => {
            reviewGenService.updateContact(vm.contact, shouldMove).then(processSuccessfulAddContact).catch(handleError);
          })
        }
      })
    };

    vm.cancel = function () {
      $state.go("^");
    };


    function processData(promises) {
      var currentContact = promises.contact;
      vm.state = 'Loaded';
    }

    vm.hasError = function (input) {
      if (!input) return;
      return input.$invalid && (!input.$pristine || vm.formSubmitted);
    };

    vm.submit = function(valid){
      vm.createEditContact(valid);
    }

    activate();

    function activate() {
      vm.state = 'Loading';
      vm.formSubmitted = false;
      if (vm.mode == 'create') {
        vm.contact = vm.defaultContact();
        vm.contact.campaignId = campaign._id.$oid;
      }
      else {
        if ($stateParams.contact) {
          vm.originalContact = angular.copy($stateParams.contact)
          vm.contact = $stateParams.contact;
          vm.accountConfig.accountId = vm.contact.accountId;
        } else {
          reviewGenService.getContact($stateParams.contactId).then(function (resp) {
            vm.originalContact = angular.copy(resp.data)
            vm.contact = resp.data;
            vm.accountConfig.accountId = vm.contact.accountId;
          });
        }
      }

      processData({contact: vm.contact})
    }
  });
};

